import React, { useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { FiPlusSquare } from 'react-icons/fi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FaRegMinusSquare } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import Bannerbuttonedit from '../Bannerbuttonedit/Bannerbuttonedit';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const Bannerbutton = () => {
  const [openDropdown, setOpenDropdown] = useState(null); // null, 'one', or 'two'

  function getOrdinalSuffix(n) {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}

  return (
  <div className="space-y-4 w-full">
  {/* Dropdown 1 */}
  <div className="w-full">
    {/* Header */}
     <div className="flex items-center gap-2 p-2 text-xl border-b border-gray-500">
           {/* Info icon with tooltip */}
           <span
             data-tooltip-id="bannerContentTooltip"
             data-tooltip-html={`
               <div class='tooltip-bubble'>
                 <div class='tooltip-content'>
                   Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                   Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
                 </div>
                 <div class='tooltip-tail'></div>
               </div>
             `}
             className="cursor-pointer mt-1 text-gray-700"
           >
             <HiOutlineInformationCircle />
           </span>
     
           <h1 className='text-gray-700'>Banner Button</h1>
             <FiPlusSquare
             className="text-blue-600 cursor-pointer"
             onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
           />
     
           <div
             className="cursor-pointer"
             onClick={() =>
               setOpenDropdown(openDropdown === 'one' ? null : 'one')
             }
           >
             {openDropdown === 'one' ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
           </div>
     
           {/* Tooltip instance */}
           <Tooltip
             id="bannerContentTooltip"
             place="bottom"
             offset={10}
             className="!bg-transparent !p-0 ms-28 !rounded-none"
           />
         </div>

    {/* Dropdown Content with transition */}
  <div
  className={`transition-all duration-500 overflow-hidden text-sm w-full ${
    openDropdown === 'one'
      ? 'max-h-[230px] border border-gray-700 rounded-b-md rounded-t-md'
      : 'max-h-0 border-0'
  }`}
>

  {/* Horizontal Scroll Container */}
  <div className="overflow-x-auto w-full ">
    {/* Row with scrollable items */}
    <div className="flex flex-nowrap w-max gap-4 p-2">
  {[...Array(5)].map((_, i) => (
    <div key={i} className="p-3 min-w-[280px]">
      <div className="flex justify-between items-center mb-2">
        <h2 className="w-fit text-lg text-gray-800">{`${i + 1}${getOrdinalSuffix(i + 1)} Banner Image`}</h2>
        <h1 className="text-blue-600 text-lg cursor-pointer mr-3 mt-1">
          <FaRegMinusSquare />
        </h1>
      </div>
      <div >
        <Bannerbuttonedit/>
      </div>
    </div>
  ))}
</div>
  </div>
</div>

  </div>
</div>




  );
};
export default Bannerbutton;